module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_salud.a8829071.jpg";